/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionFichierGridDto
 */
export interface InscriptionFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierGridDto
     */
    idinscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InscriptionFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InscriptionFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the InscriptionFichierGridDto interface.
 */
export function instanceOfInscriptionFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionFichierGridDtoFromJSON(json: any): InscriptionFichierGridDto {
    return InscriptionFichierGridDtoFromJSONTyped(json, false);
}

export function InscriptionFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinscriptionFichier': !exists(json, 'idinscriptionFichier') ? undefined : json['idinscriptionFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function InscriptionFichierGridDtoToJSON(value?: InscriptionFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinscriptionFichier': value.idinscriptionFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

